<!--
 * @Author: ymk
 * @Date: 2020-07-23 09:52:48
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-24 18:30:54
 * @FilePath: \car-demo\src\App.vue
-->
<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import axios from "axios";
import cache from "./utils/cache";
import loading from "@/components/Loading"

export default {
	name: 'app',
	components:{
		loading
	},
	// metaInfo: {
	// 	title: 'dsadas',
	// 	titleTemplate: '%s | 活动版',
	// },
	data() {
		return {
			title: '',
			load: false,
		}
	},
	metaInfo() {
		return {
			title: this.title,
			// meta: [
			// 	{ vmid: 'description', name: 'description', content: this.description }
			// ]
		}
	},
	mounted() {
		this.init()
		this.shareUrlInit()
	},
	methods: {
		init(){
			if(cache.get('_activityInfo')){
				let activityInfo = JSON.parse(cache.get('_activityInfo'));
				this.title = activityInfo.title;
			}
		},
		/**
		 * 分享地址配置
		 */
		shareUrlInit() {
			//分享链接|以下路由中,可分享当前链接出去,其他地方的分享,分享链接为活动首页
			var routeNameArr = [
				'Home',
				'FindDriving',
				'CouponSection',
				'Complain',
				'Pintuan',
				'Ranking',
				'Instructor',
				'Customer',
				'StList',
				'User',
				'CustomForm',
				'LuckyDraw',
				'Rules',
				'Reward',
				'StDetail',
				'AllClassType',
				'ClassTypeDetail',
				'ClassDetail',
				'AllCoach',
				'CoachDetail',
			]
			if (routeNameArr.includes(this.$route.name) && window.shareConf) {
				window.shareConf.fx_url = window.location.href
				shareDiy()

			}
		},
	},
}
</script>

<style lang="less">
@import './styles/index.less';
.val-content .nut-textinput input{
  color: #808080;
}
</style>
